import './editPercentage.scss';
import {AbstractEditParameterComponent, EditParameterComponentScope} from "../AbstractEditParameterComponent";
import {ConditionParameterService} from "../../../services/ConditionParameterService";

interface EditPercentageScope extends EditParameterComponentScope {

}

export class EditPercentageParameter extends AbstractEditParameterComponent {

    static instance = () => Object.assign(AbstractEditParameterComponent.instance(), {
        template: require('./editPercentage.html'),
        controller: AbstractEditParameterComponent.controllerInstance.concat([EditPercentageParameter]),
    });


    constructor($scope: EditPercentageScope,
                $mdDialogService: angular.material.IDialogService,
                parameterService: ConditionParameterService,
    ) {
        super($scope, $mdDialogService, parameterService);
    }
}